import { SchedulerSubWorkOrderOnMachine } from './sub-wo-on-machine';
import { SchedulerItem } from './item';
import { SchedulerWorkOrder } from './work-order';
import { Stage } from '../../../api/elite/types/stages';

export class SchedulerSubWorkOrder extends SchedulerItem {
  readonly TYPE = 'sub_work_order';
  id: number;
  transactionId: number;
  quantity: number;
  workOrderId: number;

  workOrder: SchedulerWorkOrder;

  machinesSubWorkOrders: SchedulerSubWorkOrderOnMachine[] = [];

  stage: Stage = undefined;
  stageId: number;

  quantityOut: number = undefined;
  quantityOutScrap: number = undefined;

  quantityPlanned: number = 0;

  get priority(): boolean {
    return this.workOrder.priority;
  }
  set priority(val: boolean) {
    this.workOrder.priority = val;
  }

  get itemsOnMachine(): SchedulerSubWorkOrderOnMachine[] {
    return this.machinesSubWorkOrders;
  }
  set itemsOnMachine(value: SchedulerSubWorkOrderOnMachine[]) {
    this.machinesSubWorkOrders = value;
  }

  get title(): string {
    return this.workOrder.transactionNumber;
  }

  static fromObject(object: SchedulerSubWorkOrder): SchedulerSubWorkOrder {
    const subWorkOrder = new SchedulerSubWorkOrder();
    Object.assign(subWorkOrder, object);
    const workOrder = new SchedulerWorkOrder();
    Object.assign(workOrder, object.workOrder);
    subWorkOrder.workOrder = workOrder;
    return subWorkOrder;
  }

  getItemOnMachineByMachineId(
    machineId: number
  ): SchedulerSubWorkOrderOnMachine {
    return this.machinesSubWorkOrders.find(
      (item) => item.machineId === machineId
    );
  }

  factoryItemOnMachine(
    subOnMachine: SchedulerSubWorkOrderOnMachine
  ): SchedulerSubWorkOrderOnMachine {
    const itemOnMachineClass = new SchedulerSubWorkOrderOnMachine();
    Object.assign(itemOnMachineClass, subOnMachine);
    this.machinesSubWorkOrders = [
      ...this.machinesSubWorkOrders,
      itemOnMachineClass,
    ];
    return subOnMachine;
  }
}
